export default __webpack_public_path__ + "static/media/Censio_Main_Illustrations_5.ca8350c1.gif";